/* ==========================================================================
   PAW POWER — SITE-WIDE BEHAVIOUR

   Deliberately small. The theme already owns the cart drawer, search,
   filters, sort, currency selector and mega menu; this only adds what the
   redesign needs on top:

     - sticky header once the announcement bar scrolls away
     - quick-add from product cards, reusing the theme's own cart events
     - newsletter inline success state
     - a shared toast

   Loaded on every template from layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ----------------------------------------------------------------------
     Money formatting — mirrors Shopify's money filter
     ---------------------------------------------------------------------- */
  function formatMoney(cents, format) {
    var fmt = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    function thousands(num, sep, decSep, decimals) {
      if (isNaN(num) || num === null) return '0';
      var fixed = (num / 100.0).toFixed(decimals == null ? 2 : decimals);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (sep || ','));
      return whole + (parts[1] ? (decSep || '.') + parts[1] : '');
    }
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    var m = fmt.match(ph);
    var token = m ? m[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = thousands(cents, ',', '.', 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, '.', ',', 2); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, '.', ',', 0); break;
      case 'amount_with_apostrophe_separator': value = thousands(cents, "'", '.', 2); break;
      default: value = thousands(cents, ',', '.', 2);
    }
    return fmt.replace(ph, value);
  }

  /* ----------------------------------------------------------------------
     Toast
     ---------------------------------------------------------------------- */
  var toastEl = null, toastTimer = null;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'PP-Toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    // force reflow so the transition runs when re-showing
    toastEl.offsetHeight; // eslint-disable-line no-unused-expressions
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ----------------------------------------------------------------------
     Sticky header

     The theme's header is static. Rather than change its markup we flip a
     class once the page has scrolled past the announcement bar, which the
     stylesheet turns into position:sticky.
     ---------------------------------------------------------------------- */
  function initStickyHeader() {
    var header = $('.Header');
    if (!header || header.classList.contains('Header--transparent')) return;

    // Prestige has its own sticky header, switched on by "Enable sticky header"
    // and reported as isSticky in the section settings blob. If the theme is
    // already handling it, stay out of the way — two implementations would
    // fight over position and offset.
    var section = header.closest('[data-section-type="header"]') || $('[data-section-type="header"]');
    if (section) {
      try {
        var cfg = JSON.parse(section.getAttribute('data-section-settings') || '{}');
        if (cfg.isSticky) return;
      } catch (e) { /* malformed settings — fall through to our own sticky */ }
    }

    var bar = $('.AnnouncementBar');
    var trigger = bar ? bar.offsetHeight : 0;
    var ticking = false;

    function update() {
      ticking = false;
      if (window.pageYOffset > trigger) header.classList.add('pp-stuck');
      else header.classList.remove('pp-stuck');
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ----------------------------------------------------------------------
     Quick add

     Cards carry data-pp-quick-add="<variantId>". On success we dispatch the
     theme's own 'product:added' event so the existing mini-cart re-renders —
     no second cart implementation.
     ---------------------------------------------------------------------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-pp-quick-add]') : null;
      if (!btn || btn.disabled) return;

      e.preventDefault();
      var id = btn.getAttribute('data-pp-quick-add');
      if (!id) return;

      btn.classList.add('is-loading');
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      }).then(function (res) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        btn.classList.remove('is-loading');
        if (!res.ok) {
          return res.json().then(function (c) {
            toast((c && c.description) || 'Could not add to cart');
          });
        }
        btn.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: 1 } }));
        toast(btn.getAttribute('data-pp-added-label') || 'Added to cart');
      }).catch(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        btn.classList.remove('is-loading');
        toast('Network error. Please try again.');
      });
    });
  }

  /* ----------------------------------------------------------------------
     Newsletter — inline success without leaving the page
     ---------------------------------------------------------------------- */
  function initNewsletter() {
    // Shopify redirects back with ?customer_posted=true on success
    if (location.search.indexOf('customer_posted=true') === -1) return;
    $$('[data-pp-news-success]').forEach(function (el) { el.hidden = false; });
    var form = $('[data-pp-news-form]');
    if (form) form.hidden = true;
  }

  /* ----------------------------------------------------------------------
     Boot
     ---------------------------------------------------------------------- */
  function boot() {
    initStickyHeader();
    initQuickAdd();
    initNewsletter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.PPTheme = { formatMoney: formatMoney, toast: toast };
})();
